<template>
  <section id="deviceuserlist" class="content">
    <!--no matching result-->
    <div
      class="accessory-list-default"
      v-show="isShowEmptyList"
    >
      <img
        src="../../../static/img/icon_no_matching_result.svg"
        class="center-block accessory-list-no-matching-img"
      >
      <div class="text-center col-sm-6 col-sm-offset-3">
        <h4
          class="page-404-tips"
        >This user is maybe not registered on this platform.</h4>
      </div>
    </div>
    <!--no matching result-->
    <div
      class="agent-list"
      v-bind:value="userList"
      v-for="(item,index) in userList"
      v-bind:key="index"
    >
      <div class="row">
        <div class="col-lg-1 col-md-2 col-sm-2 col-xs-3">
          <img
            class="device-user-list-portrait"
            v-if="item.photo == ''"
            src="../../../static/img/img_device_user_default.png"
          >
          <img
            class="device-user-list-portrait"
            v-else
            v-bind:src="'https://d.din.bz/'+item.photo"
          >
        </div>
        <div
          class="col-lg-7 col-md-6 col-sm-10 col-xs-9 device-user-list-data"
        >
          <span
            class="device-user-list-username"
          >{{item.uid}}</span>
          <!--show device list-->
          <p
            class="device-user-list-devicename"
            v-show="!item.isShowDevice"
            :id="item.uid+'showdevicebtn'"
          >
            <button
              type="button"
              class="btn btn-xs btn-default"
              v-on:click="toLoadMoreDevice(item.uid,index)"
            >show the binding device</button>
          </p>

          <div
            class="row"
            :id="item.uid"
            v-for="(device) in item.devices"
            v-bind:key="device.deviceid"
          >
            <p
              class="col-sm-11 col-xs-10 device-user-list-show-device-name-mar device-user-list-show-device-name-go-to"
              :id="item.uid+'devicelist'"
              v-on:click="toSearchDevice(device.devicename, device.deviceid)"
            >
              {{device.devicename}}
              <span
                class="device-user-list-show-device-id"
              >
                (
                <span>{{device.deviceid}}</span> )
              </span>
            </p>
            <button
              type="button"
              class="btn btn-xs btn-default pull-right col-sm-1 col-xs-2 device-user-list-show-device-name-mar"
              v-show="toGetDevice(index)"
              v-on:click="toShowDevicePermission(device, index)"
              data-toggle="modal"
              data-target="#device-user-list-set-device"
            >
              <i class="fa fa-edit (alias)"></i>
            </button>
          </div>
          <div
            class="row"
            :id="item.uid+'emptydevice'"
            v-show="item.isShowNone"
          >
            <p
              class="col-xs-11 device-user-list-show-device-name"
            >
              <span
                class="device-user-list-show-device-id"
              >none</span>
            </p>
          </div>

          <!-- / show device list-->
        </div>
        <div
          class="col-lg-4 col-md-4 col-sm-12 col-xs-12 btn-device-user-list"
        >
          <button
            class="btn btn-info btn-sm btn-agent-edit pull-right"
            data-toggle="modal"
            data-target="#modal-user-add-device"
            @click="toAddDevice(item.uid)"
          >Add Device</button>
          <button
            class="btn btn-primary btn-sm btn-device-user-list-setting pull-right"
            data-toggle="modal"
            v-on:click="toProfile(item,index)"
            data-target="#modal-user-profile"
          >Profile</button>
        </div>
      </div>
    </div>
    <!-- add User -->
    <div
      class="add-app-bgcolor"
      data-toggle="modal"
      @click="toAddUser"
      data-target="#modal-new-a-device-user"
    >
      <button class="add-app-btn">
        <span class="btn add-app">
          <i class="fa fa-plus"></i>
        </span>
      </button>
    </div>
    <!-- /add User -->
    <!--Profile dialog-->
    <div class="modal fade in" id="modal-user-profile">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">User Profile</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div
                class="form-group modal-user-profile-head"
              >
                <div
                  class="modal-self-profile-upload-head modal-user-profile-head-input"
                >
                  <input>
                </div>
                <img
                  class="modal-user-profile-img modal-user-profile-head-img"
                  v-if="currentProfileUser.photo == ''"
                  src="../../../static/img/img_device_user_default.png"
                >
                <img
                  class="modal-user-profile-img"
                  v-else
                  v-bind:src="'https://d.din.bz/'+currentProfileUser.photo"
                >
                <h5>{{currentProfileUser.uid}}</h5>
              </div>

              <div
                class="input-group form-group modal-user-profile-content"
              >
                <span class="input-group-addon">
                  <i class="fa fa-key"></i>
                </span>
                <input
                  id="current_password"
                  class="form-control modal-user-profile-input"
                  v-bind:value="currentProfileUser.password"
                  placeholder="Keep the current password"
                >
              </div>
              <div
                class="input-group form-group modal-user-profile-content"
              >
                <span class="input-group-addon">
                  <i class="fa fa-envelope"></i>
                </span>
                <input
                  id="current_email"
                  class="form-control modal-user-profile-input"
                  placeholder="Email Address"
                  v-bind:value="currentProfileUser.mail"
                >
              </div>
              <div
                class="input-group form-group modal-user-profile-content"
              >
                <span
                  class="input-group-addon modal-user-profile-content-icon"
                >
                  <i class="fa fa-phone"></i>
                </span>
                <input
                  id="current_phone"
                  class="form-control modal-user-profile-input"
                  placeholder="Phone Number"
                  v-bind:value="getPhone(currentProfileUser.phone)"
                >
                <div class="input-group-btn">
                  <select
                    id="current_phone_zone"
                    class="btn btn-warning modal-user-profile-area-code"
                    v-bind:value="getPhoneZone(currentProfileUser.phone)"
                  >
                    <option
                      v-for="(item, index) in phonezonelist"
                      v-bind:key="index"
                      v-bind:value="phonezonelist[index]"
                    >{{phonezonelist[index] + ' ' + phonezonaname[index]}}</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              aria-label="Close"
            >Cancel</button>
            <button
              type="button"
              class="btn btn-info"
              v-on:click="toDoUpdataUser"
            >Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Profile dialog-->
    <!--Add device dialog-->
    <div class="modal fade in" id="modal-user-add-device">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              Add Device
              <i
                class="fa fa-angle-right modal-device-user-title-name"
              ></i>
              <span>{{currentAddDevice.uid}}</span>
            </h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div
                class="row modal-user-setting-add-device-row"
              >
                <div class="col-xs-1">
                  <i
                    class="fa fa-desktop modal-user-setting-icon"
                  ></i>
                </div>
                <div
                  class="col-xs-8 modal-user-setting-table-input"
                >
                  <input
                    class="form-control"
                    placeholder="Input the Device ID"
                    v-model="currentAddDevice.deviceid"
                  >
                </div>
                <div
                  class="col-xs-3 modal-user-setting-auth-add"
                >
                  <span>Authority:&nbsp;</span>
                  <select
                    class="choose-existing-agent-select"
                    v-model="currentAddDevice.permission"
                  >
                    <option value="30">Admin</option>
                    <option value="20">User</option>
                    <option value="10">Guest</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              aria-label="Close"
            >Cancel</button>
            <button
              type="button"
              class="btn btn-info"
              @click="toDoAddDevice"
            >Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Add device dialog-->
    <!--Set device dialog-->
    <div
      class="modal fade in"
      id="device-user-list-set-device"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">
              Authority Management
              <i
                class="fa fa-angle-right modal-device-user-title-name"
              ></i>
              <span>{{currentUserDeviceSetting.username}}</span>
            </h4>
          </div>
          <div class="modal-body">
            <form class="form-horizontal">
              <div
                class="row modal-user-setting-add-device-row"
              >
                <div class="col-xs-1">
                  <i class="fa fa-desktop"></i>
                </div>
                <div
                  class="col-xs-8 modal-user-setting-table-input"
                >
                  <p
                    class="device-user-list-show-device-name"
                  >
                    {{currentUserDeviceSetting.devicename}}
                    <span
                      class="device-user-list-show-device-id"
                    >({{currentUserDeviceSetting.deviceid}})</span>
                  </p>
                </div>
                <div
                  class="col-xs-3 modal-user-setting-auth-add modal-user-setting-auth-sel"
                >
                  <span>Authority:&nbsp;</span>
                  <select
                    id="change_device_permission"
                    class="choose-existing-agent-select"
                    v-bind:value="currentUserDeviceSetting.permission"
                  >
                    <option value="30">Admin</option>
                    <option value="20">User</option>
                    <option value="10">Guest</option>
                  </select>
                </div>
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-danger pull-left"
              data-toggle="dropdown"
            >Unbind</button>
            <ul class="dropdown-menu pull-left alert-del">
              <li>
                <i
                  class="icon fa fa-warning alert-del-warning"
                ></i>Confirm to unbind?
              </li>
              <li>
                <button class="btn btn-default">Cancel</button>
                <button
                  class="btn btn-danger"
                  v-on:click="toUnbindUser"
                >Unbind</button>
              </li>
            </ul>
            <button
              type="button"
              class="btn btn-info"
              v-on:click="toChangPermission"
            >Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ Set device dialog-->
    <!--New a User dialog-->
    <div class="modal fade in" id="modal-new-a-device-user">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
            <h4 class="modal-title">New a Device User</h4>
          </div>
          <div class="modal-body">
            <div class="form-horizontal">
              <div class="table-responsive">
                <div class="form-group">
                  <label
                    class="col-xs-3 control-label agent-edit-modal-name"
                  >Username</label>
                  <div
                    class="col-xs-9 agent-edit-modal-name"
                  >
                    <input
                      class="form-control"
                      placeholder="User ID"
                      v-model="currentAddDeviceUser.uid"
                    >
                  </div>
                </div>
                <div class="form-group">
                  <label
                    class="col-xs-3 control-label agent-edit-modal-name"
                  >Password</label>
                  <div
                    class="col-xs-9 agent-edit-modal-name"
                  >
                    <input
                      class="form-control"
                      placeholder="Keep the default password(123456)"
                      v-model="currentAddDeviceUser.password"
                    >
                  </div>
                </div>
                <div class="form-group" v-show="false">
                  <label
                    class="col-xs-3 control-label agent-edit-modal-name"
                  >Email Address</label>
                  <div
                    class="col-xs-9 agent-edit-modal-name"
                  >
                    <input
                      class="form-control"
                      placeholder="(Optional)"
                      v-model="currentAddDeviceUser.mail"
                    >
                  </div>
                </div>

                <div class="form-group" v-show="false">
                  <label
                    class="col-xs-3 control-label agent-edit-modal-name"
                  >Mobile Phone</label>
                  <div
                    class="col-xs-9 agent-edit-modal-name"
                  >
                    <input
                      class="form-control"
                      placeholder="(Optional)"
                      v-model="currentAddDeviceUser.phone"
                    >
                    <div class="new-device-user-area-code">
                      <select
                        id
                        class="btn btn-warning modal-user-profile-area-code"
                        v-bind:value="getPhoneZone(currentProfileUser.phone)"
                      >
                        <option
                          v-for="(item, index) in phonezonelist"
                          v-bind:value="phonezonelist[index]"
                          v-bind:key="index"
                        >{{phonezonelist[index] + ' ' + phonezonaname[index]}}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-default pull-left"
              data-dismiss="modal"
              aria-label="Close"
            >Cancel</button>
            <button
              type="button"
              class="btn btn-info"
              @click="toDoAddUser"
            >Save changes</button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!--/ New a User dialog-->
  </section>
  <!-- /.content -->
</template>
<script>
import api from "../../api";
import utils from "../../utils";
import global from "../Global.vue";
import config from "../../config";

export default {
  name: "DeviceUser",
  data() {
    return {
      userList: [],
      currentProfileUser: {},
      currentUserDeviceSetting: {},
      currentAddDevice: {},
      currentAddDeviceUser: {},
      currentIndex: -1,
      phonezonaname: [
        "Afghanistan",
        "Albania",
        "Algeria",
        "American Samoa",
        "Andorra",
        "Angola",
        "Anguilla",
        "Antarctica",
        "Antigua and Barbuda",
        "Argentina",
        "Armenia",
        "Aruba",
        "Australia",
        "Austria",
        "Azerbaijan",
        "Bahamas",
        "Bahrain",
        "Bangladesh",
        "Barbados",
        "Belarus",
        "Belgium",
        "Belize",
        "Benin",
        "Bermuda",
        "Bhutan",
        "Bolivia",
        "Bosnia and Herzegovina",
        "Botswana",
        "Brazil",
        "British Virgin Islands",
        "Brunei",
        "Bulgaria",
        "Burkina Faso",
        "Burma (Myanmar)",
        "Burundi",
        "Cambodia",
        "Cameroon",
        "Canada",
        "Cape Verde",
        "Cayman Islands",
        "Central African Republic",
        "Chad",
        "Chile",
        "China",
        "Christmas Island",
        "Cocos (Keeling) Islands",
        "Colombia",
        "Comoros",
        "Republic of the Congo",
        "Democratic Republic of the Congo",
        "Cook Islands",
        "Costa Rica",
        "Croatia",
        "Cuba",
        "Cyprus",
        "Czech Republic",
        "Denmark",
        "Djibouti",
        "Dominica",
        "Dominican Republic",
        "Timor-Leste",
        "Ecuador",
        "Egypt",
        "El Salvador",
        "Equatorial Guinea",
        "Eritrea",
        "Estonia",
        "Ethiopia",
        "Falkland Islands",
        "Faroe Islands",
        "Fiji",
        "Finland",
        "France",
        "French Polynesia",
        "Gabon",
        "Gambia",
        "Gaza Strip",
        "Georgia",
        "Germany",
        "Ghana",
        "Gibraltar",
        "Greece",
        "Greenland",
        "Grenada",
        "Guam",
        "Guatemala",
        "Guinea",
        "Guinea-Bissau",
        "Guyana",
        "Haiti",
        "Honduras",
        "Hong Kong",
        "Hungary",
        "Iceland",
        "India",
        "Indonesia",
        "Iran",
        "Iraq",
        "Ireland",
        "Isle of Man",
        "Israel",
        "Italy",
        "Ivory Coast",
        "Jamaica",
        "Japan",
        "Jordan",
        "Kazakhstan",
        "Kenya",
        "Kiribati",
        "Kosovo",
        "Kuwait",
        "Kyrgyzstan",
        "Laos",
        "Latvia",
        "Lebanon",
        "Lesotho",
        "Liberia",
        "Libya",
        "Liechtenstein",
        "Lithuania",
        "Luxembourg",
        "Macau",
        "Macedonia",
        "Madagascar",
        "Malawi",
        "Malaysia",
        "Maldives",
        "Mali",
        "Malta",
        "Marshall Islands",
        "Mauritania",
        "Mauritius",
        "Mayotte",
        "Mexico",
        "Micronesia",
        "Moldova",
        "Monaco",
        "Mongolia",
        "Montenegro",
        "Montserrat",
        "Morocco",
        "Mozambique",
        "Namibia",
        "Nauru",
        "Nepal",
        "Netherlands",
        "Netherlands Antilles",
        "New Caledonia",
        "New Zealand",
        "Nicaragua",
        "Niger",
        "Nigeria",
        "Niue",
        "Norfolk Island",
        "Northern Mariana Islands",
        "North Korea",
        "Norway",
        "Oman",
        "Pakistan",
        "Palau",
        "Panama",
        "Papua New Guinea",
        "Paraguay",
        "Peru",
        "Philippines",
        "Pitcairn Islands",
        "Poland",
        "Portugal",
        "Puerto Rico",
        "Qatar",
        "Romania",
        "Russia",
        "Rwanda",
        "Saint Barthelemy",
        "Samoa",
        "San Marino",
        "Sao Tome and Principe",
        "Saudi Arabia",
        "Senegal",
        "Serbia",
        "Seychelles",
        "Sierra Leone",
        "Singapore",
        "Slovakia",
        "Slovenia",
        "Solomon Islands",
        "Somalia",
        "South Africa",
        "South Korea",
        "Spain",
        "Sri Lanka",
        "Saint Helena",
        "Saint Kitts and Nevis",
        "Saint Lucia",
        "Saint Martin",
        "Saint Pierre and Miquelon",
        "Saint Vincent and the Grenadines",
        "Sudan",
        "Suriname",
        "Swaziland",
        "Sweden",
        "Switzerland",
        "Syria",
        "Taiwan",
        "Tajikistan",
        "Tanzania",
        "Thailand",
        "Togo",
        "Tokelau",
        "Tonga",
        "Trinidad and Tobago",
        "Tunisia",
        "Turkey",
        "Turkmenistan",
        "Turks and Caicos Islands",
        "Tuvalu",
        "United Arab Emirates",
        "Uganda",
        "United Kingdom",
        "Ukraine",
        "Uruguay",
        "United States",
        "Uzbekistan",
        "Vanuatu",
        "Holy See (Vatican City)",
        "Venezuela",
        "Vietnam",
        "US Virgin Islands",
        "Wallis and Futuna",
        "West Bank",
        "Yemen",
        "Zambia",
        "Zimbabwe"
      ],
      phonezonelist: [
        "+93",
        "+355",
        "+213",
        "+1684",
        "+376",
        "+244",
        "+1264",
        "+672",
        "+1268",
        "+54",
        "+374",
        "+297",
        "+61",
        "+43",
        "+994",
        "+1242",
        "+973",
        "+880",
        "+1246",
        "+375",
        "+32",
        "+501",
        "+229",
        "+1441",
        "+975",
        "+591",
        "+387",
        "+267",
        "+55",
        "+1284",
        "+673",
        "+359",
        "+226",
        "+95",
        "+257",
        "+855",
        "+237",
        "+1",
        "+238",
        "+1345",
        "+236",
        "+235",
        "+56",
        "+86",
        "+61",
        "+61",
        "+57",
        "+269",
        "+242",
        "+243",
        "+682",
        "+506",
        "+385",
        "+53",
        "+357",
        "+420",
        "+45",
        "+253",
        "+1767",
        "+1809",
        "+670",
        "+593",
        "+20",
        "+503",
        "+240",
        "+291",
        "+372",
        "+251",
        "+500",
        "+298",
        "+679",
        "+358",
        "+33",
        "+689",
        "+241",
        "+220",
        "+970",
        "+995",
        "+49",
        "+233",
        "+350",
        "+30",
        "+299",
        "+1473",
        "+1671",
        "+502",
        "+224",
        "+245",
        "+592",
        "+509",
        "+504",
        "+852",
        "+36",
        "+354",
        "+91",
        "+62",
        "+98",
        "+964",
        "+353",
        "+44",
        "+972",
        "+39",
        "+225",
        "+1876",
        "+81",
        "+962",
        "+7",
        "+254",
        "+686",
        "+381",
        "+965",
        "+996",
        "+856",
        "+371",
        "+961",
        "+266",
        "+231",
        "+218",
        "+423",
        "+370",
        "+352",
        "+853",
        "+389",
        "+261",
        "+265",
        "+60",
        "+960",
        "+223",
        "+356",
        "+692",
        "+222",
        "+230",
        "+262",
        "+52",
        "+691",
        "+373",
        "+377",
        "+976",
        "+382",
        "+1664",
        "+212",
        "+258",
        "+264",
        "+674",
        "+977",
        "+31",
        "+599",
        "+687",
        "+64",
        "+505",
        "+227",
        "+234",
        "+683",
        "+672",
        "+1670",
        "+850",
        "+47",
        "+968",
        "+92",
        "+680",
        "+507",
        "+675",
        "+595",
        "+51",
        "+63",
        "+870",
        "+48",
        "+351",
        "+1",
        "+974",
        "+40",
        "+7",
        "+250",
        "+590",
        "+685",
        "+378",
        "+239",
        "+966",
        "+221",
        "+381",
        "+248",
        "+232",
        "+65",
        "+421",
        "+386",
        "+677",
        "+252",
        "+27",
        "+82",
        "+34",
        "+94",
        "+290",
        "+1869",
        "+1758",
        "+1599",
        "+508",
        "+1784",
        "+249",
        "+597",
        "+268",
        "+46",
        "+41",
        "+963",
        "+886",
        "+992",
        "+255",
        "+66",
        "+228",
        "+690",
        "+676",
        "+1868",
        "+216",
        "+90",
        "+993",
        "+1649",
        "+688",
        "+971",
        "+256",
        "+44",
        "+380",
        "+598",
        "+1",
        "+998",
        "+678",
        "+39",
        "+58",
        "+84",
        "+1340",
        "+681",
        "+970",
        "+967",
        "+260",
        "+263"
      ],
      currentDeviceListHeight: 0,
      currentPage: 0,
      isSearchByName: false,
      searchName: "",
      isLoadMore: false,
      isShowEmptyList: false
    };
  },
  created() {
    this.$bus.on("searchdeviceuser", this.init);
  },
  beforeDestroy() {
    this.$bus.off("searchdeviceuser", this.init);
    this.toShowSearchUserKey("");
  },
  methods: {
    init(key) {
      this.isLoadMore = false;
      this.currentPage = 0;
      this.currentDeviceListHeight = -1;
      window.scrollTo(0, 0);
      if (utils.isEmpty(key) || utils.isEmpty(key.key)) {
        this.toGetAllUser();
      } else {
        this.toGetAllUserByUid(key.key, 0);
      }
    },
    toGetAllUser(page) {
      this.isSearchByName = false;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        page: page
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/getdeviceuser?_type=json", params)
        .then(response => {
          var data = response.data;
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              if (!this.isLoadMore) {
                this.userList = JSON.parse(
                  utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
                );
                for (var i = 0; i < this.userList.length; i++) {
                  this.userList[i].isShowDevice = false;
                  this.userList[i].isShowNone = false;
                }
              } else {
                var tempList = JSON.parse(
                  utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
                );
                this.userList = this.userList.concat(tempList);
                for (var j = 0; j < this.userList.length; j++) {
                  this.userList[j].isShowDevice = false;
                  this.userList[j].isShowNone = false;
                }
              }
            }
            if (this.userList.length <= 0) {
              this.isShowEmptyList = true;
            } else {
              this.isShowEmptyList = false;
            }
          }
        });
    },
    toGetAllUserByUid(key, page) {
      this.isSearchByName = true;
      this.searchName = key;
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: key,
        page: page
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/getdeviceuser?_type=json", params)
        .then(response => {
          var data = response.data;
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            if (data.Result) {
              if (!this.isLoadMore) {
                this.userList = JSON.parse(
                  utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
                );
                for (var i = 0; i < this.userList.length; i++) {
                  this.userList[i].isShowDevice = false;
                  this.userList[i].isShowNone = false;
                }
              } else {
                var tempList = JSON.parse(
                  utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
                );
                this.userList = this.userList.concat(tempList);
                for (var j = 0; j < this.userList.length; j++) {
                  this.userList[j].isShowDevice = false;
                  this.userList[j].isShowNone = false;
                }
              }
            }
            if (this.userList.length <= 0) {
              this.isShowEmptyList = true;
            } else {
              this.isShowEmptyList = false;
            }
          }
        });
    },
    toAddUser() {
      this.currentAddDeviceUser = {};
    },
    toDoAddUser() {
      if (utils.isEmpty(this.currentAddDeviceUser.mail)) {
        this.currentAddDeviceUser.mail = "";
      }
      if (utils.isEmpty(this.currentAddDeviceUser.phone)) {
        this.currentAddDeviceUser.phone = "";
      }
      if (utils.isEmpty(this.currentAddDeviceUser.password)) {
        this.currentAddDeviceUser.password = "123456";
      }

      var params = new URLSearchParams();
      var jsons = {
        regfrom: this.$route.query.appid,
        password: this.currentAddDeviceUser.password,
        uid: this.currentAddDeviceUser.uid,
        mail: this.currentAddDeviceUser.mail,
        phone: this.currentAddDeviceUser.phone,
        system: "admin"
      };
      this.currentAddDeviceUser.password = "";
      params.append("json", JSON.stringify(jsons));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .requestWithServerUrl(
          "post",
          config.blackholeServerURI,
          config.addDeviceuser,
          params
        )
        .then(response => {
          var data = response.data;
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
            utils.showMsg("fail");
          } else {
            if (data.Result) {
              window.location.reload();
            }
          }
        });
    },
    toProfile(item, index) {
      this.currentIndex = index;
      this.currentProfileUser = {};
      this.currentProfileUser = item;
    },
    getPhone(phone) {
      if (typeof phone === "undefined") {
        return;
      }
      return phone.split(" ")[1];
    },
    getPhoneZone(phone) {
      if (typeof phone === "undefined") {
        return;
      }

      if (phone.split(" ")[0] === "") {
        return "+86";
      }
      return phone.split(" ")[0];
    },
    toUnbindUser() {
      var params = new URLSearchParams();
      var jsons = {
        deviceid: this.currentUserDeviceSetting.deviceid,
        unbinduid: this.currentUserDeviceSetting.username
      };
      params.append("json", JSON.stringify(jsons));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .requestWithServerUrl(
          "post",
          config.blackholeServerURI,
          "/device/unbinduser/" + this.$route.query.appid,
          params
        )
        .then(response => {
          var data = response.data;
          if (data.Status !== 1) {
          } else {
            for (var i = 0; i < this.userList.length; i++) {
              if (
                !utils.isEmpty(this.userList[i].devices) &&
                this.userList[i].uid === this.currentUserDeviceSetting.username
              ) {
                for (var j = 0; j < this.userList[i].devices.length; j++) {
                  if (
                    this.userList[i].devices[j].deviceid ===
                    this.currentUserDeviceSetting.deviceid
                  ) {
                    var temp = this.userList[i];
                    temp.devices.splice(j, 1);
                    if (temp.devices.length <= 0) {
                      temp.isShowNone = true;
                      //                        window.jQuery('#' + this.userList[i].uid + 'emptydevice').show()
                    }

                    this.userList.splice(i, 1, temp);
                    window.jQuery("#device-user-list-set-device").modal("hide");
                    return;
                  }
                }
              }
            }
          }
        });
    },
    toChangPermission() {
      if (
        this.currentUserDeviceSetting.permission !==
        window.jQuery("#change_device_permission").val()
      ) {
        var params = new URLSearchParams();
        var jsons = {
          deviceid: this.currentUserDeviceSetting.deviceid,
          uid: this.currentUserDeviceSetting.username,
          newpermission: parseInt(
            window.jQuery("#change_device_permission").val()
          )
        };
        params.append("json", JSON.stringify(jsons));
        if (window.localStorage) {
          params.append("token", this.$router.app.$store.state.user.token);
        }
        api
          .requestWithServerUrl(
            "post",
            config.blackholeServerURI,
            "/device/modifydevicecontact/v2/" + this.$route.query.appid,
            params
          )
          .then(response => {
            var data = response.data;
            if (data.Status !== 1) {
            } else {
              for (var i = 0; i < this.userList.length; i++) {
                if (
                  !utils.isEmpty(this.userList[i].devices) &&
                  this.userList[i].uid ===
                    this.currentUserDeviceSetting.username
                ) {
                  for (var j = 0; j < this.userList[i].devices.length; j++) {
                    if (
                      this.userList[i].devices[j].deviceid ===
                      this.currentUserDeviceSetting.deviceid
                    ) {
                      var temp = this.userList[i];
                      temp.devices[j].permission = window
                        .jQuery("#change_device_permission")
                        .val();
                      this.userList.splice(i, 1, temp);
                      window
                        .jQuery("#device-user-list-set-device")
                        .modal("hide");
                      return;
                    }
                  }
                }
              }
            }
          });
      }
    },
    toLoadMoreDevice(uid, index) {
      //        window.jQuery('#' + uid).show()
      //       load server data
      window.jQuery("#" + uid + "showdevicebtn").hide(200);
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: uid
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/getdevicesbyuser?_type=json", params)
        .then(response => {
          var data = response.data;
          if (data.Status !== 1) {
          } else {
            var temp = this.userList[index];
            temp.devices = JSON.parse(
              utils.getDecodeRC4Hex(data.Result, global.APP_SECRET)
            );
            temp.isShowDevice = true;
            if (temp.devices.length <= 0) {
              temp.isShowNone = true;
              //                 window.jQuery('#' + uid + 'emptydevice').show()
            }
            this.userList.splice(index, 1, temp);
          }
        });
      //        load success
    },
    toGetDevice(index) {
      //        判断是否有主机
      //        没有主机 返回false
      if (this.userList[index].devices.length > 0) {
        return true;
      }
      return false;
    },
    toAddDevice(userid) {
      this.$set(this.currentAddDevice, "uid", userid);
      this.$set(this.currentAddDevice, "deviceid", "");
      this.$set(this.currentAddDevice, "permission", 30);
    },
    toDoAddDevice() {
      var params = new URLSearchParams();
      var jsons = {
        deviceid: this.currentAddDevice.deviceid.trim(),
        uid: this.currentAddDevice.uid,
        permission: parseInt(this.currentAddDevice.permission)
      };
      params.append("json", JSON.stringify(jsons));
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
      api
        .requestWithServerUrl(
          "post",
          config.blackholeServerURI,
          config.userAddDevice + this.$route.query.appid,
          params
        )
        .then(response => {
          this.$store.commit("TOGGLE_FULLSCREEN_LOADING");
          var data = response.data;
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
          } else {
            for (var i = 0; i < this.userList.length; i++) {
              if (
                this.userList[i].uid === this.currentAddDevice.uid &&
                this.userList[i].isShowDevice
              ) {
                var temp;
                if (!utils.isEmpty(this.userList[i].devices)) {
                  temp = this.userList[i];
                  temp.devices.push({
                    deviceid: this.currentAddDevice.deviceid,
                    devicename: data.Result.devicename,
                    permission: this.currentAddDevice.permission
                  });
                  this.userList.splice(i, 1, temp);
                } else {
                  temp = this.userList[i];
                  temp.devices = [];
                  temp.devices.push({
                    deviceid: this.currentAddDevice.deviceid,
                    devicename: data.Result.devicename,
                    permission: this.currentAddDevice.permission
                  });
                  this.userList.splice(i, 1, temp);
                }
                window
                  .jQuery("#" + this.currentAddDevice.uid + "emptydevice")
                  .hide();
                window.jQuery("#modal-user-add-device").modal("hide");
                return;
              }
            }
            window.jQuery("#modal-user-add-device").modal("hide");
          }
        });
    },
    toShowDevicePermission(device, index) {
      this.currentUserDeviceSetting.username = this.userList[index].uid;
      this.currentUserDeviceSetting = {
        username: this.userList[index].uid,
        devicename: device.devicename,
        deviceid: device.deviceid,
        permission: device.permission
      };
    },
    toDoUpdataUser() {
      var params = new URLSearchParams();
      var jsons = {
        appid: this.$route.query.appid,
        uid: this.currentProfileUser.uid,
        pw: window.jQuery("#current_password").val(),
        email: window.jQuery("#current_email").val(),
        phone:
          this.phonezonelist[
            window.jQuery("#current_phone_zone").get(0).selectedIndex
          ] +
          " " +
          window.jQuery("#current_phone").val()
      };
      params.append(
        "json",
        utils.getRC4Hex(JSON.stringify(jsons), global.APP_SECRET)
      );
      if (window.localStorage) {
        params.append("token", this.$router.app.$store.state.user.token);
      }
      api
        .request("post", "/updatadeviceuser?_type=json", params)
        .then(response => {
          var data = response.data;
          /* Checking if error object was returned from the server */
          if (data.Status !== 1) {
            utils.showMsg(data.ErrorMessage);
          } else {
            this.$set(
              this.userList[this.currentIndex],
              "mail",
              window.jQuery("#current_email").val()
            );
            this.$set(
              this.userList[this.currentIndex],
              "phone",
              this.phonezonelist[
                window.jQuery("#current_phone_zone").get(0).selectedIndex
              ] +
                " " +
                window.jQuery("#current_phone").val()
            );
            //              this.userList[this.currentIndex].mail = this.currentProfileUser.mail
            //              this.userList[this.currentIndex].phone = this.phonezonelist[window.jQuery('#current_phone_zone').get(0).selectedIndex] +
            //                ' ' + window.jQuery('#current_phone').val()
            window.jQuery("#modal-user-profile").modal("hide");
          }
        });
    },
    winScroll(e) {
      if (
        this.currentDeviceListHeight < window.jQuery("#deviceuserlist").height()
      ) {
        if (
          window.jQuery(window).scrollTop() + window.jQuery(window).height() >=
          window.jQuery("#deviceuserlist").height()
        ) {
          this.currentDeviceListHeight =
            window.jQuery(window).scrollTop() + window.jQuery(window).height();
          this.isLoadMore = true;
          this.getNextPage();
        }
      }
    },
    getNextPage() {
      this.currentPage = this.currentPage + 1;
      if (!this.isSearchByName) {
        this.toGetAllUser(this.currentPage);
      } else {
        this.toGetAllUserByUid(this.searchName, this.currentPage);
      }
    },
    toSearchDevice(devicename, deviceid) {
      this.$router.push(
        "/aboutdevice?appid=" +
          this.$route.query.appid +
          "&appname=" +
          this.$route.query.appname +
          "&deviceid=" +
          deviceid +
          "&devicename=" +
          devicename +
          "&online=1" +
          "&t=" +
          this.$store.state.devicetoken
      );
    },
    toShowSearchUserKey(userkey) {
      this.$bus.emit("showsearchuserkey", { key: userkey.trim() });
    }
  },
  mounted() {
    if (utils.isEmpty(this.$route.query.key)) {
      this.init();
    } else {
      this.toShowSearchUserKey(this.$route.query.key);
      this.init({ key: this.$route.query.key });
    }
    window.addEventListener("scroll", this.winScroll, false);
  }
};
</script>

<style>
.example-modal .modal {
  position: fixed;
  display: block;
  z-index: 999999;
}
.example-modal .modal {
  /*background: transparent !important;*/
  background: #000000 0.3 !important;
}
.form-horizontal .form-group {
  margin-right: 0px;
  margin-left: 0px;
}
</style>



// WEBPACK FOOTER //
// DeviceUser.vue?0a025e79